/////////////////////////////////////////////////////////////////
// How a listing's photos sit in the marketplace's photo frames.  //
//                                                               //
// Product cards always fill their square frame ("cover"), so     //
// every card in a row looks the same. On the product page the    //
// brand chooses, per listing, whether a photo that doesn't match //
// the frame is shown in full on white ("contain") or zoomed to   //
// fill the frame edge to edge with its edges trimmed ("cover").  //
/////////////////////////////////////////////////////////////////

// Saved to listing.attributes.publicData.
export const IMAGE_FIT_KEY = 'imageFit';

// The whole photo is visible, centred on white. Best for cut-out product shots.
export const IMAGE_FIT_CONTAIN = 'contain';
// The photo fills the frame and its edges are trimmed. Best for lifestyle shots.
export const IMAGE_FIT_COVER = 'cover';

export const IMAGE_FIT_OPTIONS = [IMAGE_FIT_CONTAIN, IMAGE_FIT_COVER];
export const DEFAULT_IMAGE_FIT = IMAGE_FIT_CONTAIN;

/**
 * Turn anything into one of IMAGE_FIT_OPTIONS, so a missing or unexpected
 * value (e.g. listings saved before brands could choose) shows the whole photo.
 *
 * @param {*} value
 * @returns {string} IMAGE_FIT_CONTAIN or IMAGE_FIT_COVER
 */
export const sanitizeImageFit = value =>
  IMAGE_FIT_OPTIONS.includes(value) ? value : DEFAULT_IMAGE_FIT;

/**
 * How the photos of the given listing should sit in their frames.
 *
 * @param {Object} listing
 * @returns {string} IMAGE_FIT_CONTAIN or IMAGE_FIT_COVER
 */
export const getListingImageFit = listing =>
  sanitizeImageFit(listing?.attributes?.publicData?.[IMAGE_FIT_KEY]);

/**
 * Describe the shape of a photo, so a brand can be told how it will look.
 *
 * @param {Object} dimensions { width, height }
 * @returns {string|null} 'square', 'portrait', 'landscape' or null if unknown
 */
export const getImageOrientation = dimensions => {
  const { width, height } = dimensions || {};
  if (!width || !height) {
    return null;
  }
  const ratio = width / height;
  // Within 5% of square counts as square: phones and cropping tools rarely
  // produce an exact 1:1.
  return Math.abs(ratio - 1) <= 0.05 ? 'square' : ratio < 1 ? 'portrait' : 'landscape';
};
